import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import styles from "./styles.module.css";
import cx from "classnames";
import Logo from "./icons/logo";
import { BOOTCAMPS_SECTION_ID } from "../courses";
import { ABOUT_SECTION_ID } from "../сardWithExpectation/сardWithExpectation";
import { EXPERTS_SECTION_ID } from "../experts";
import { ThreeIcon } from "./icons/three.icon";
import { ThreeMobIcon } from "./icons/three.mob.icon";
import Asterisk from "./icons/asterisk";
import SvgKross from "./icons/kross";

const Header = ({ mainPage }) => {
  const mainTitle = mainPage.title;
  const btnTitle = mainPage.buttonText;
  const subtitle = mainPage.subtitle;

  const [isShown, setIsShown] = useState(true);

  function getSectionVerticalPosition(id) {
    return (
      document.getElementById(id).getBoundingClientRect().top + window.scrollY
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.root}>
        <div
          className={cx(styles.banner, {
            [styles.hidden]: !isShown,
          })}
        >
          <Asterisk className={styles.displayNoneMobile} />
          <div className={styles.displayNoneMobile}>
            &nbsp;Moscow Coding School теперь Guide DAO.&nbsp;
          </div>
          <div className={styles.displayNoneDesktop}>
            &nbsp;MCS теперь Guide DAO.&nbsp;
          </div>
          <span className={styles.moreInfo}>
            <a href="https://www.instagram.com/p/CmOQNByLAbM/" target="_blank">
              Узнать больше
            </a>
          </span>
          <div onClick={() => setIsShown(false)} className={styles.krossIcon}>
            <SvgKross />
          </div>
        </div>
        <div
          className={cx(styles.flex, {
            [styles.margin]: !isShown,
          })}
        >
          <div className={styles.logo}>
            <Logo style={{ top: 20 }} />
          </div>
          <div className={styles.flexMenu}>
            <div
              onClick={() => {
                window.scrollTo({
                  top: getSectionVerticalPosition(BOOTCAMPS_SECTION_ID),
                  behavior: "smooth",
                });
              }}
              style={{ marginRight: "40px", cursor: "pointer" }}
            >
              Буткемпы
            </div>
            <div
              onClick={() => {
                window.scrollTo({
                  top: getSectionVerticalPosition(EXPERTS_SECTION_ID),
                  behavior: "smooth",
                });
              }}
              style={{ marginRight: "40px", cursor: "pointer" }}
            >
              Эксперты
            </div>
            <div
              onClick={() => {
                window.scrollTo({
                  top: getSectionVerticalPosition(ABOUT_SECTION_ID),
                  behavior: "smooth",
                });
              }}
              style={{ marginRight: "40px", cursor: "pointer" }}
            >
              DAO
            </div>
          </div>
          <div>
            <a
              href="https://learn.guidedao.xyz/"
              target="_blank"
              className={styles.btnLogin}
            >
              Войти
            </a>
          </div>
        </div>

        <div className={styles.gridRow}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "40px",
            }}
          >
            <h1 className={styles.title}>
              <span
                dangerouslySetInnerHTML={{
                  __html: mainTitle,
                }}
              ></span>
              <span className={styles.threeMobIcon}>
                <ThreeMobIcon />
              </span>
              <span className={styles.threeIcon}>
                <ThreeIcon />
              </span>
            </h1>

            <h2
              className={styles.subtitle}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            ></h2>
            <button
              className={styles.startBtn}
              style={{
                marginTop: "40px",
                background: "#C7F450",
                border: "none",
                padding: "7px 33px",
                borderRadius: "41px",
                cursor: "pointer",
                color: "#070809",
              }}
              onClick={() => {
                window.scrollTo({
                  top: getSectionVerticalPosition(BOOTCAMPS_SECTION_ID),
                  behavior: "smooth",
                });
              }}
              dangerouslySetInnerHTML={{
                __html: btnTitle,
              }}
            ></button>
          </div>
        </div>
      </div>
      <div className={cx(styles.slider, styles.sliderForMobile)}>
        <div className={styles.slide}></div>
      </div>
      <div className={cx(styles.slider, styles.sliderForDesktop)}>
        <StaticImage
          className={cx(styles.mainStaticImage)}
          alt="Future"
          loading="eager"
          src="https://images.ctfassets.net/67gkhzpoimdx/7JWH49l58lAfyOaiCxSc3s/9727e6fa70a49366f17204bf4c7934db/Background.png"
        />
      </div>
    </div>
  );
};

export default Header;
